import { ldap } from './advanced/ldap';
import { snmp } from './advanced/snmp';
import emailNotify from './advanced/emailNotify';
import encryption from './advanced/encryption';
import diskReplacement from './advanced/diskReplacement';
import nvme from './advanced/nvme';

export default {
  namespaced: true,
  modules: {
    ldap,
    snmp,
    emailNotify,
    encryption,
    diskReplacement,
    nvme
  }
};
